import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { activities, activityCategories } from "../data/activities";
import { ActivityCard } from "./ActivityCard";
import type { ActivityCategory } from "../types/cafe";
interface ActivitiesSectionProps {
  onJoin: (activityId: string) => void;
}
export function ActivitiesSection({
  onJoin
}: ActivitiesSectionProps) {
  const [filter, setFilter] = useState<"Semua" | ActivityCategory>("Semua");
  const visible = filter === "Semua" ? activities : activities.filter(a => a.category === filter);
  return <section id="activities" className="py-20 lg:py-28" data-id="element-16" data-mp="h79ikhtwemo2">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-17" data-mp="h5on8pzrezp5">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between" data-id="element-18" data-mp="c97ypuonejbj">
          <div className="max-w-xl" data-id="element-19" data-mp="31y9yuo0kr44p">
            <h2 className="text-3xl font-semibold tracking-tight text-ink sm:text-4xl" data-id="element-20" data-mp="31zblzquv7h2s">
              Aktivitas di sela seruputan
            </h2>
            <p className="mt-4 text-base leading-relaxed text-ink-muted" data-id="element-21" data-mp="2se7o7dm5nmjp">
              Aktivitas mingguan pilihan untuk pesepeda, pekerja remote, para pembuat, dan siapa
              saja yang ingin menemukan teman baru.
            </p>
          </div>

          <div role="tablist" aria-label="Filter aktivitas berdasarkan kategori" className="-mx-5 flex gap-2 overflow-x-auto px-5 pb-1 sm:mx-0 sm:px-0" data-id="element-22" data-mp="2jd15qyzy41nt">
            {activityCategories.map(cat => {
            const active = filter === cat;
            return <button key={cat} role="tab" aria-selected={active} onClick={() => setFilter(cat)} className={`relative whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors duration-150 ${active ? "text-cream" : "text-ink-muted hover:text-ink"}`} data-id="element-23" data-mp="2egj6gendwviv">
                  {active && <motion.span layoutId="activity-filter" className="absolute inset-0 rounded-full bg-sage" transition={{
                duration: 0.25,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-24" data-mp="18rxlw5nm2on" />}
                  <span className="relative" data-id="element-25" data-mp="3jlzg55l5w0eh">{cat}</span>
                </button>;
          })}
          </div>
        </div>

        <motion.div layout className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-26" data-mp="k5awztqnoc80">
          <AnimatePresence mode="popLayout" data-id="element-27" data-mp="g628b3ah34jb">
            {visible.map(activity => <ActivityCard key={activity.id} activity={activity} onJoin={onJoin} data-id="element-28" data-mp="b54q4qpgqaht" />)}
          </AnimatePresence>
        </motion.div>
      </div>
    </section>;
}